//価格
const TICKET_AMOUNT_EARLY = 38000, //早割販売・大人
      TICKET_AMOUNT = 43000, //一般販売・大人
      TICKET_AMOUNT_CHILD_EARLY = 20000, //早割販売・小中学生
      TICKET_AMOUNT_CHILD = 23000, //一般販売・小中学生
      TICKET_AMOUNT_MASTER_EARLY = 33000, //早割販売・マスター
      TICKET_AMOUNT_MASTER = 38000, //一般販売・マスター
      TICKET_AMOUNT_BABY_EARLY = 4000, //一般販売・幼児
      TICKET_AMOUNT_BABY = 5000, //一般販売・幼児
      //ファミリー
      TICKET_AMOUNT_FAMLY_A = 48000, //ファミリー早割 A
      TICKET_AMOUNT_FAMLY_B = 63000, //ファミリー早割 B
      TICKET_AMOUNT_FAMLY_C = 81000, //ファミリー早割 C
      TICKET_AMOUNT_FAMLY_D = 96000, //ファミリー早割 D
      DISCOUNT_FAMLY_MASTER = 5000, //ファミリー構成員がマスター@1名につき
      DISCOUNT_FAMLY_BABY = 12000, //ファミリー構成員が幼児@1名につき
      //オプション
      //WAX_AMOUNT = 5500, //ホットワックス追加オプション '22-'23シーズンは廃止
      POSTAL_AMOUNT = 500; //郵送料金

//年齢からチケットタイプ判別
const calcTicketType = function(age){
  if(age === null) return '';
  if(age.full >= 70){
    return 'Gマスター（70歳以上）';
  }else if(age.full >= 50){
    return 'マスター（50歳以上）';
  }else if(age.grade < 6){
    return '幼児';
  }else if(age.grade < 15){
    return '小中学生';
  }
  return '大人';
}

//割引処理
const checkFamilyDiscount = function(adult, child, master_count, baby_count){
  let amount = 0;
  let master_discount = 0;
  let baby_discount = 0;
  if(!is_early_discount) return false;
  while(adult.length && child.length){
    if(adult.length >= 2 && child.length >= 2){
      adult.splice(0,2);
      child.splice(0,2);
      amount += TICKET_AMOUNT_FAMLY_D;
      master_discount += 2;
      baby_discount += 2;
    }else if(adult.length >= 2 && child.length >= 1){
      adult.splice(0,2);
      child.splice(0,1);
      amount += TICKET_AMOUNT_FAMLY_C;
      master_discount += 2;
      baby_discount += 2;
    }else if(adult.length >= 1 && child.length >= 2){
      adult.splice(0,1);
      child.splice(0,2);
      amount += TICKET_AMOUNT_FAMLY_B;
      master_discount += 1;
      baby_discount += 1;
    }else if(adult.length >= 1 && child.length >= 1){
      adult.splice(0,1);
      child.splice(0,1);
      amount += TICKET_AMOUNT_FAMLY_A;
      master_discount += 1;
      baby_discount += 1;
    }
  }
  while(master_discount--){
    if(master_count > 0 && master_count--) amount -= DISCOUNT_FAMLY_MASTER;
  }
  while(baby_discount--){
    if(baby_count > 0 && baby_count--) amount -= DISCOUNT_FAMLY_BABY;
  }
  return {
    adult: adult,
    child: child,
    amount: amount
  }
}


const getTicketFee = function(type){
  if(!!type.value.match('マスター') && is_early_discount){
    return TICKET_AMOUNT_MASTER_EARLY;
  }else if(!!type.value.match('マスター')){
    return TICKET_AMOUNT_MASTER;
  }else if(type.value == '幼児' && is_early_discount){
    return TICKET_AMOUNT_BABY_EARLY;
  }else if(type.value == '幼児'){
    return TICKET_AMOUNT_BABY;
  }else if(type.value == '小中学生' && is_early_discount){
    return TICKET_AMOUNT_CHILD_EARLY;
  }else if(type.value == '小中学生'){
    return TICKET_AMOUNT_CHILD;
  }else if(is_early_discount){
    return TICKET_AMOUNT_EARLY;
  }
  return TICKET_AMOUNT;
}

const isMaster = function(type){
  if(!!type.value.match('マスター')) return true;
}
const isAdult = function(type){
  if(type.value == '大人') return true;
}
const isChild = function(type){
  if(type.value == '小中学生') return true;
}
const isBaby = function(type){
  if(type.value == '幼児') return true;
}

const birthdayInputHandler = function(e){
  const parent = e.target.closest('.form-cover');
  const type = parent.type;
  const age = calcAge(parent, e);
  type.value = calcTicketType(age);
  calcAmountTotal();
}

const calcAge = function(parent, e = null){
  const birth_input = parent.birth_input;
  if(birth_input.year.value == '') return null;
  let birth_date = parent.birth_date;
  if(e){
    switch (e.target) {
      case birth_input.year:
       birth_date.setFullYear(e.target.value);
       break;
      case birth_input.month:
       birth_date.setMonth(e.target.value-1);
       break;
      case birth_input.date:
       birth_date.setDate(e.target.value);
       break;
    }
  }else{
    if(birth_input.year.value != '') birth_date.setFullYear(birth_input.year.value);
    if(birth_input.year.value != '') birth_date.setMonth(birth_input.month.value-1);
    if(birth_input.year.value != '') birth_date.setDate(birth_input.date.value);
  }
  let age = form_date.getFullYear() - birth_date.getFullYear();
  let full_age = age;
  const birth_day = new Date(form_date.getFullYear(), birth_date.getMonth(), birth_date.getDate())
  const grade_day = new Date(form_date.getFullYear(), 4-1, 1)
  if (form_date < birth_day) full_age--;
  //new Date(2022,4-1,1) < new Date(2022,4-1,1)
  if (grade_day < birth_day) age--;
  return {
    full: full_age,
    grade: age
  }
}
const calcTicketTypeAll = function(){
  const parents = document.querySelectorAll('.form-cover');
  parents.forEach((item, i) => {
    const type = item.type;
    const age = calcAge(item);
    type.value = calcTicketType(age);
  });
}

const calcAmountTotal = function(e){
  const target = document.querySelector('.amount input');
  const post_mail = document.querySelector('input[name="事前郵送"][value="希望する"]');
  // const options = document.querySelectorAll('input[value="ホットワックス追加"]');
  const ticket_types = document.querySelectorAll('input[name^="チケット区分"]');
  let amount = 0;
  let master_count = 0;
  let baby_count = 0;
  let adult = [];
  let child = [];
  // options.forEach((item, i) => {
  //   if(item.checked){
  //     amount += WAX_AMOUNT;
  //   }
  // });
  if(post_mail.checked == true){
    amount += POSTAL_AMOUNT;
  }
  ticket_types.forEach((item, i) => {
    if(item.value == '') return;
    if(isMaster(item)) master_count++;
    if(isBaby(item)) baby_count++;
    if(isAdult(item) || isMaster(item)) adult.push(item);
    if(isChild(item) || isBaby(item)) child.push(item);
  });
  let family_discount = checkFamilyDiscount(adult, child, master_count, baby_count);
  if(family_discount){
    adult = family_discount.adult;
    child = family_discount.child;
    amount += family_discount.amount;
  }
  //残りの計算
  adult.forEach((item, i) => {
    amount += getTicketFee(item);
  });
  child.forEach((item, i) => {
    amount += getTicketFee(item);
  });
  target.value = amount.toLocaleString();
  return amount;
}

const form_date = new Date();
const early_discount_date = new Date(form_date.getFullYear(),12-1,1);//12/1
const early_discount_start_date = new Date(form_date.getFullYear(),8-1,30);//8/30（動作テスト） 一般公開9/1
const is_early_discount = (form_date < early_discount_date && form_date > early_discount_start_date);

module.exports = {

  setEvent: function(parent, target, id){
    if(target == null ) return;
    if(target.type == 'hidden') return;
    parent.array_num = id || 0;
    parent.birth_date = new Date();
    parent.birth_input = {
      year: parent.querySelector(`input[name=年${id}]`),
      month: parent.querySelector(`select[name=月${id}]`),
      date: parent.querySelector(`select[name=日${id}`)
    };
    parent.type = parent.querySelector(`input[name="チケット区分${id}"]`);
    parent.type.disabled = true;
    parent.birth_input.year.addEventListener('keyup', birthdayInputHandler);
    parent.birth_input.year.addEventListener('change', birthdayInputHandler);
    parent.birth_input.month.addEventListener('change', birthdayInputHandler);
    parent.birth_input.date.addEventListener('change', birthdayInputHandler);
    // const option = parent.querySelector('input[value="ホットワックス追加"]');
    // option.addEventListener('click',calcAmountTotal);
  },

  getAmountTotal: function(){
    return calcAmountTotal();
  },

  calqAmountTotal: function(){
    return calcAmountTotal();
  },

  calqTicketTypeAll: function(){
    return calcTicketTypeAll();
  }

};
